import { render } from "./UserEntry.vue?vue&type=template&id=763b0ac2&scoped=true"
import script from "./UserEntry.vue?vue&type=script&lang=js"
export * from "./UserEntry.vue?vue&type=script&lang=js"

import "./UserEntry.vue?vue&type=style&index=0&id=763b0ac2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763b0ac2"]])

export default __exports__